import { createRouter, createWebHistory } from "vue-router";
import routes from "./routes";
import store from "@/store";
import { commitTypes } from "@/store-types";

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    linkActiveClass: "active",
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) return savedPosition;
        return { left: 0, top: 0 };
    },
});

// نگهبان مسیر — همین‌جا (زمان بارگذاری ماژول) ثبت می‌شود تا پیش از
// نخستین ناوبری فعال باشد؛ در غیر این صورت داشبرد بدون ورود نمایش داده می‌شد.
router.beforeEach((to, from, next) => {
    const meta = to.meta || {};

    if (
        !Object.prototype.hasOwnProperty.call(meta, "access") ||
        meta.access.includes("*")
    ) {
        next();
        return;
    }

    if (!store.state.signedIn) {
        store.commit(commitTypes.SET_REDIRECT, { name: to.name, params: to.params });
        next({ name: "UserLogin" });
        return;
    }

    if (!meta.access.includes(store.state.user.Role)) {
        next({ name: "UserLogin" });
        return;
    }

    next();
});

// vue-router 4 دیگر برای ناوبری تکراری throw نمی‌کند؛ فقط خطاهای واقعی را لاگ می‌کنیم.
router.onError((err) => {
    // eslint-disable-next-line no-console
    console.error("[router]", err && err.message);
});

export default router;
